import { render, staticRenderFns } from "./ControllerQuestionAnswer.vue?vue&type=template&id=521126ca&scoped=true&"
import script from "./ControllerQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./ControllerQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521126ca",
  null
  
)

export default component.exports